var render = function (_h,_vm) {var _c=_vm._c;return _c('div',_vm._b({staticClass:"middlebar",class:_vm.data.staticClass || ''},'div',_vm.data.attrs,false),[_c('div',{staticClass:"middlebar-start"},[_vm._t("start")],2),_c('div',{staticClass:"middlebar-end"},[_vm._t("end")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }